export default {
  children: [
    {
      name: 'Home',
      title: 'Главная',
      children: [
        {
          name: 'News',
          title: 'Новости',
          children: [
            {
              name: 'NewsDetail'
            }
          ]
        },
        {
          name: 'Articles',
          title: 'Статьи',
          children: [
            {
              name: 'ArticleDetail'
            },
            {
              name: 'ArticlesSection'
            }
          ]
        },
        {
          name: 'Seminars',
          title: 'Конференции и вебинары',
          children: [
            {
              name: 'SeminarDetail'
            }
          ]
        },
        {
          name: 'StockDetail'
        },
        {
          name: 'SpecialOffer',
          title: 'Мои спецпредложения'
        },
        {
          name: 'PrivilegeProgram',
          title: 'Программа привилегий',
          children: [
            {
              name: 'PrivilegeProgramRules',
              title: 'Правила программы'
            }
          ]
        },
        {
          name: 'Faq',
          title: 'FAQ',
          children: [
            {
              name: 'FaqCheapseo',
              title: 'SEO-продвижение быстро и дешево? Будьте осторожны!'
            },
            {
              name: 'FaqPersonalData',
              title: 'Владельцам сайтов: изменения в Законе «О персональных данных»'
            },
            {
              name: 'FaqAboutSeoText',
              title: 'Памятка по работе с seo-текстами для клиента Demis Group'
            },
            {
              name: 'FaqHowToWork',
              title: 'Информация по работе с данным сервисом'
            },
            {
              name: 'FaqAboutDemis',
              title: 'Памятка клиенту по работе с компанией Demis Group'
            },
            {
              name: 'FaqStopSmoking',
              title: 'Информация о социальном проекте Demis Group'
            }
          ]
        }
      ]
    },
    {
      name: 'Seo',
      title: 'Продвижение сайтов',
      children: [
        {
          name: 'Positions',
          title: 'Текущие позиции'
        },
        {
          name: 'Indicators',
          title: 'Показатели сайта'
        },
        {
          name: 'Works',
          title: 'Работы по продвижению'
        },
        {
          name: 'MonthlyReport',
          title: 'Отчеты по SEO'
        },
        {
          name: 'Documents',
          title: 'Бухгалтерские документы'
        }
      ]
    },
    {
      name: 'Context',
      title: 'Контекстная реклама',
      children: [
        {
          name: 'ContextStatistics',
          title: 'Статистика'
        },
        {
          name: 'ContextBrief',
          title: 'Сводка'
        },
        {
          name: 'ContextDocuments',
          title: 'Бухгалтерские документы'
        }
      ]
    },
    {
      name: 'sermMediaplan',
      title: 'Управление репутацией',
      children: [
        {
          name: 'sermKPI',
          title: 'KPI'
        },
        {
          name: 'sermTimeline',
          title: 'Таймлайн проекта'
        },
        {
          name: 'sermAnalytics',
          title: 'SERM-аналитика'
        },
        {
          name: 'sermReviews',
          title: 'Отзывы'
        },
        {
          name: 'sermMonitoring',
          title: 'Мониторинг и коммуникация'
        },
        {
          name: 'sermReport',
          title: 'Отчет'
        }
      ]
    }
  ]
}
